<template lang="pug">
.dropdown
  slot(name="trigger")
    a.dropdown-toggle.btn(
      :class="allTriggerClasses"
      role="button"
      data-toggle="dropdown"
    )
      .d-flex.align-items-center
        span.m-0
          | {{ label }}
        i.hi.hi-10(:class="iconClass")
  ul.dropdown-menu(:class="directionClass")
    slot
</template>

<script>
import { lowerCase, upperFirst } from 'lodash-es';

export default {
  name: 'AppDropdown',
  provide() {
    return { dropdownTracking: () => this.trackingContext };
  },
  props: {
    label: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
    },
    type: {
      type: String,
      default: 'default',
    },
    size: {
      type: String,
      default: undefined,
    },
    direction: {
      type: String,
      default: 'right',
    },
    triggerClasses: {
      type: String,
      default: undefined,
    },
    icon: {
      type: String,
      default: 'caret',
    },
    // Opt in to tracking the clicks of its items, meant for the "Actions" menus.
    track: {
      type: Boolean,
      default: false,
    },
    // Defaults to the name of the component that renders the dropdown, e.g. "Clients table actions".
    trackScope: {
      type: String,
      default: null,
    },
    // Extra properties sent with every item click, e.g. `{ client_id: 1 }`.
    trackProps: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    trackingContext() {
      const ownerName = this.$parent?.$options?.name;
      const scope = this.trackScope || (ownerName && upperFirst(lowerCase(ownerName)));

      return { track: this.track, props: { ...(scope && { scope }), ...this.trackProps } };
    },
    allTriggerClasses() {
      return [this.typeClass, this.sizeClass, this.triggerClasses, this.disabledClass].join(' ');
    },
    typeClass() {
      return `btn-${this.type}`;
    },
    disabledClass() {
      return this.disabled ? 'disabled' : '';
    },
    sizeClass() {
      switch (this.size) {
        case 'small':
          return 'btn-sm';
        case 'large':
          return 'btn-lg';
        default:
          return '';
      }
    },
    directionClass() {
      return `dropdown-menu-${this.direction}`;
    },
    iconClass() {
      return `hi-${this.icon}`;
    },
  },
};
</script>
